import {DatePipe}                               from '@angular/common';
import {booleanAttribute, Component, input}     from '@angular/core';
import {GlobalDataTypesDict, HkitRecordLogIntf} from '@djsharkk/logr-types';
import {TableRowBase}                           from '../table-row-base';
import {TableRow}                               from '../table-wrapper/table-wrapper.component';

@Component({
			   selector   : 'app-table-row-hkit',
			   imports: [
				   DatePipe
			   ],
			   templateUrl: './table-row-hkit.component.html',
			   styleUrl   : './table-row-hkit.component.css'
		   })
export class TableRowHkitComponent extends TableRowBase<HkitRecordLogIntf> {
	row = input.required<TableRow>();
	showDate = input(false, {transform: booleanAttribute});
	detailed = input(false, {transform: booleanAttribute});
	protected readonly GlobalRecordTypeDict = GlobalDataTypesDict;
}
